import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6756e025"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "segment-select__action-container"
}

import { IonButton } from '@ionic/vue';
import { Icons } from '@/enums/Icons';
import { IonSegment, IonSegmentButton } from '@ionic/vue';
import BaseIcon from '@/components/BaseIcon.vue';
import { computed } from 'vue';
import useAlertOnEvent from '@/composables/useAlertOnEvent';


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentSelect',
  props: {
    modelValue: {},
    popUpLabels: {},
    options: {}
  },
  emits: ['update:modelValue', 'onChange'],
  setup(__props: any, { emit: __emit }) {

const alertOnEvent = useAlertOnEvent();

const props = __props;

const classList = computed(() => {
  return ['segment-select', { 'segment-select--with-info-action': props.popUpLabels && props.popUpLabels.length }];
});

const emit = __emit;

const emitNewValue = (event: any) => {
  emit('update:modelValue', event.detail.value);
  emit('onChange', event.detail.value);
};

const onInfoClick = async (header: string) => {
  await alertOnEvent.fireSimpleAlert(header);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(classList.value)
  }, [
    (_ctx.popUpLabels && _ctx.popUpLabels.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "segment-select__action-item",
              key: `segment-select-action-item-${index}-${option.value}`
            }, [
              (_ctx.popUpLabels[index])
                ? (_openBlock(), _createBlock(_unref(IonButton), {
                    key: 0,
                    class: "segment-select__info-action",
                    color: "light",
                    onClick: ($event: any) => (onInfoClick(_ctx.popUpLabels[index]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(BaseIcon, {
                        class: "segment-select__info-action-icon",
                        icon: _unref(Icons).Info
                      }, null, 8, ["icon"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(IonSegment), {
      class: "segment-select__element",
      onIonChange: emitNewValue,
      value: _ctx.modelValue
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
          return (_openBlock(), _createBlock(_unref(IonSegmentButton), {
            key: `segment-select-${index}-${option.value}`,
            value: option.value,
            class: "segment-select__button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(option.label), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value"])
  ], 2))
}
}

})